import React from "react";

export const Loading = ({ title = "Loading", value = null, fullscreen = true}) => {
    let style = {};
    if (fullscreen) {
        style = {position: "fixed"};
    }
    return <div className={"loading" + (fullscreen ? " fullscreen-loading" : "")} style={style}>
        <div className={"rotating-border"}>
            &nbsp;
        </div>
        <img src={"/public/canold-logo.webp"} alt={"canold logo"} className={"animate-logo"}/>
        {value !== null && value !== undefined ? <h3>{value}% complete</h3> : ""}
        <p>{title}</p>
    </div>;

};

export default Loading;
